import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getGroupsPagination, getUserGroupsPagination } from '../services/groups';
import usePagination from './usePagination';

export const useGroups = (status) => {
    const {
        paginationModel,
        setPaginationModel,
        rowsPerPageOptions,
        count,
        currentToken,
        resolveHeader
    } = usePagination();

    const handlerFetchData = async ({ queryKey }) => {
        const [, { paginationModel, status }] = queryKey;
        return getGroupsPagination(
            paginationModel.pageSize,
            currentToken(paginationModel.page),
            status
        );
    };

    const { isPending, isError, data } = useQuery({
        queryKey: ['groups', { paginationModel, status }],
        queryFn: handlerFetchData,
        keepPreviousData: true
    });

    useEffect(() => {
        if (data) {
            resolveHeader(data.headers, paginationModel.page);
        }
    }, [data]);

    return {
        data: data?.data || [],
        isLoading: isPending,
        error: isError,
        count,
        rowsPerPageOptions,
        paginationModel,
        setPaginationModel
    };
};

export const useUserGroups = (roleUUID, status) => {
    const {
        paginationModel,
        setPaginationModel,
        rowsPerPageOptions,
        count,
        currentToken,
        resolveHeader
    } = usePagination();

    const handlerFetchData = async ({ queryKey }) => {
        const [, { paginationModel, status }] = queryKey;
        return getUserGroupsPagination(
            roleUUID,
            paginationModel.pageSize,
            currentToken(paginationModel.page),
            status
        );
    };

    const { isPending, isError, data } = useQuery({
        queryKey: ['userGroups', { paginationModel, status }],
        queryFn: handlerFetchData,
        keepPreviousData: true
    });

    useEffect(() => {
        if (data) {
            resolveHeader(data.headers, paginationModel.page);
        }
    }, [data]);

    return {
        data: data?.data || [],
        isLoading: isPending,
        error: isError,
        count,
        rowsPerPageOptions,
        paginationModel,
        setPaginationModel
    };
};
